export default __webpack_public_path__ + "static/media/Walk-in-meeting.dd6a8676.png";